import React from 'react';
import { Card, CardBody, Col, Row, TabContent, TabPane } from 'reactstrap';
import { LI, UL } from '../../../../AbstractElements';
import { Hometxt, JavaScriptBehavior, Messages, Modalcontent, Profile, Settings } from '../../../../Constant';
import TabsPreventDefaultAndAnimation from '../../../../Hoc/TabsPreventDefaultAndAnimation';
import HeaderCard from '../../../Common/HeaderCard';

const JavascriptBase = ({ show, tabActive, tabActiveHandler }) => {
  return (
    <Col sm='12' xl='12'>
      <Card>
        <HeaderCard title={JavaScriptBehavior} />
        <CardBody>
          <Row>
            <Col sm='4 tab-javascript'>
              <UL className='nav-primary nav-pills bgcolor default-list'>
                <LI href='#javascript' className={tabActive === '1' ? 'list-group-item-action active' : ''} onClick={(e) => tabActiveHandler(e, '1')}>
                  {Hometxt}
                </LI>
                <LI href='#javascript' className={tabActive === '2' ? 'list-group-item-action active' : ''} onClick={(e) => tabActiveHandler(e, '2')}>
                  {Profile}
                </LI>
                <LI href='#javascript' className={tabActive === '3' ? 'list-group-item-action active' : ''} onClick={(e) => tabActiveHandler(e, '3')}>
                  {Messages}
                </LI>
                <LI href='#javascript' className={tabActive === '4' ? 'list-group-item-action active' : ''} onClick={(e) => tabActiveHandler(e, '4')}>
                  {Settings}
                </LI>
              </UL>
            </Col>
            <Col sm='8'>
              <TabContent activeTab={tabActive}>
                <TabPane tabId='1' className={`fade ${tabActive === '1' ? show : ''}`}>
                  {Modalcontent}.
                </TabPane>
                <TabPane tabId='2' className={`fade ${tabActive === '2' ? show : ''}`}>
                  {Modalcontent}.
                </TabPane>
                <TabPane tabId='3' className={`fade ${tabActive === '3' ? show : ''}`}>
                  {Modalcontent}.
                </TabPane>
                <TabPane tabId='4' className={`fade ${tabActive === '4' ? show : ''}`}>
                  {Modalcontent}.
                </TabPane>
              </TabContent>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};

export default TabsPreventDefaultAndAnimation(JavascriptBase);
